import { Button } from "@loot-os/ui/components/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@loot-os/ui/components/dialog";

import { useIgnoredUsers } from "../../lib/chat.js";

/** The players this browser hides in chat (boxed's muted-users list), each with Unignore. */
export function IgnoredUsersDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const { ignored, unignore } = useIgnoredUsers();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Ignored players</DialogTitle>
          <DialogDescription>
            Their messages are hidden on this device only. They are not told.
          </DialogDescription>
        </DialogHeader>
        {ignored.length === 0 ? (
          <p className="text-sm text-muted-foreground">You are not ignoring anyone.</p>
        ) : (
          <ul className="grid gap-2">
            {ignored.map((user) => (
              <li key={user.endUserId} className="flex items-center justify-between gap-3">
                <span className="truncate text-sm font-medium">{user.displayName}</span>
                <Button size="sm" variant="outline" onClick={() => unignore(user.endUserId)}>
                  Unignore
                </Button>
              </li>
            ))}
          </ul>
        )}
        <DialogFooter>
          <DialogClose render={<Button type="button" />}>Done</DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
